var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"icon/plus","clipPath":"url(#clip0_1266_1034)","key":0},React.createElement("path",{"id":"icon","fillRule":"evenodd","clipRule":"evenodd","d":"M9 9.5H16V7.49H9V0.5H6.99V7.5H0V9.51H7V16.51H9.01V9.51L9 9.5Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1266_1034"},React.createElement("rect",{"width":"16","height":"16","fill":"white","transform":"translate(0 0.5)"})))]);
}

Plus.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
